/*@flow*/
export const setupGA = () => {
  // Enable in production mode only.
  if (!process.env.__PROD__) return;
  window.gtag('config', process.env.REACT_APP_GA_ID);
};

export const sendPageView = (o: {
  page_title?: string,
  page_path?: string,
  page_location?: string,
}) => {
  // Enable in production mode only.
  if (!process.env.__PROD__) return;
  window.gtag('config', process.env.REACT_APP_GA_ID, o);
};
